// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".App_Header__GaTBK {\n  text-align: center;\n}", "",{"version":3,"sources":["webpack://src/App.module.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD","sourcesContent":[".Header {\n\ttext-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Header": "App_Header__GaTBK"
};
export default ___CSS_LOADER_EXPORT___;
